import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
var _excluded = ["field", "form", "subText", "displayInitialErrors", "inputRef"];
import { Field as UnionField } from "@xo-union/tk-component-fields";
import { getIn } from "formik";
import React from "react";
export var Field = function Field(props) {
  var field = props.field,
    _props$form = props.form,
    touched = _props$form.touched,
    errors = _props$form.errors,
    subText = props.subText,
    _props$displayInitial = props.displayInitialErrors,
    displayInitialErrors = _props$displayInitial === void 0 ? false : _props$displayInitial,
    inputRef = props.inputRef,
    rest = _objectWithoutProperties(props, _excluded);
  var text;
  var fieldTouched = getIn(touched, field.name) || displayInitialErrors;
  var error = getIn(errors, field.name);
  var state;
  if (fieldTouched && error) {
    text = error;
    state = 'invalid';
  } else if (fieldTouched && subText) {
    text = subText;
    state = 'valid';
  } else {
    state = 'neutral';
  }
  return /*#__PURE__*/React.createElement(UnionField, _extends({}, field, rest, {
    ref: inputRef,
    state: state,
    subText: text
  }));
};